export default {
  common: {
    home: '首页',
    models: '型号列表',
    agentBrands: '代理品牌',
    dealerBrands: '经销品牌',
    contact: '联系我们',
    nisshinbo: 'Nisshinbo',
    feihong: '飞虹',
    ketianshi: '可天士',
    more: '查看更多',
    readMore: '阅读更多',
    viewDetails: '查看详情',
    submit: '提交',
    reset: '重置',
    search: '搜索',
    filter: '筛选',
    category: '分类',
    region: '地区',
    company: '公司',
    name: '姓名',
    phone: '电话',
    email: '邮箱',
    message: '留言',
    subject: '主题',
    address: '地址',
    workingHours: '工作时间',
    confirm: '确定',
    menu: '菜单'
  },
  home: {
    latestNews: '最新动态',
    aboutUs: '关于我们',
    techFuture: '科技引领未来',
    innovation: '创新驱动发展',
    introduce: '金矽科技（香港）有限公司（Kam Zi Technology (HK) Company Ltd）是一间扎根香港的电子零件代理及贸易公司，为日清纺微电子（Nisshinbo Micro Devices）、可天士（KODENSHI AUK）及飞虹（FeiHong）等知名品牌在香港的官方代理，同时经销多个国际及本地品牌的电子元器件产品。',
    bizTitle: '公司代理品牌覆盖产品类型广泛，包括：',
    biz1: '模拟半导体与微波模块',
    biz2: '功率半导体（IGBT、MOSFET、分立器件）',
    biz3: '电源管理IC（LDO、DC/DC转换器、PMIC）',
    biz4: '音频处理IC与音量控制IC',
    biz5: '光电元件（光电二极管、光电三极管、光电开关、编码器）',
    biz6: '传感器模块与模拟前端（AFE）',
    biz7: '电池管理与保护IC',
    biz8: '工业与汽车专用ASIC/ASSP',
    introduce2: '凭借丰富多元的产品线、一站式采购服务、灵活库存管理、完善物流配送及专业技术支持，我们能快速响应客户需求并保障关键项目供货稳定。'
  },
  searchPage: {
    title: '产品搜索',
    subtitle: '输入型号名称将在所有产品数据中查找。',
    browseModels: '浏览完整型号列表',
    hintBeforeSearch: '在上方输入关键词后，点击「搜索」查看匹配的型号列表。',
    emptyAfterSearch: '未找到符合条件的型号，请尝试其它关键词或浏览完整型号列表。',
    emptySearchWarning: '请先输入型号名称再搜索。',
    productModelColumn: '产品型号',
    datasheetDownloadColumn: '产品规格书下载',
    resultCount: '共 {count} 条数据'
  },
  models: {
    clickToDownload: '点击下载',
    categoryName: '分类名称',
    feihongCatTransistor: '晶体管',
    feihongCatIgbt: 'IGBT',
    feihongCatPlaneMosfet: '平面 MOSFET',
    feihongCatSuperJunctionMosfet: '超级结 MOSFET',
    feihongCatTrenchMosfet: '沟槽 MOSFET',
    feihongProducts: '产品列表',
    feihongOfficialSite: '访问飞虹官网',
    feihongProductListDesc: '以下为飞虹产品型号列表，仅支持按产品型号与分类筛选。',
    feihongModelPlaceholder: '请输入产品型号',
    ketianshiProducts: '产品列表',
    ketianshiProductListDesc: '以下为可天士产品型号列表，仅支持按产品型号与分类筛选。',
    ketianshiModelPlaceholder: '请输入产品型号',
    kodenshiTopCategory: '顶级分类',
    kodenshiCategoryPath: '分类路径',
    kodenshiDetailUrl: '详情链接',
    kodenshiSegSensor: '传感器',
    kodenshiCatDistanceSensor: '距离传感器',
    kodenshiCatDualLens: '双透镜',
    kodenshiCatSingleLens: '单透镜',
    kodenshiCatPaperSensor: '纸张传感器',
    kodenshiCatIndustrialSensor: '工业传感器',
    kodenshiCatLaserDustSensor: '激光粉尘传感器',
    kodenshiCatEncoderModule: '编码器模组',
    kodenshiCatLightEmitting: '发光器件',
    kodenshiCatTransmissiveModule: '透过型模块',
    kodenshiCatParallelLight: '平行光光源',
    kodenshiCatSeparatedType: '分离型',
    kodenshiCatPhotodiodeArray: '光敏二极管阵列',
    kodenshiCatExcitationType: '激励型',
    kodenshiCatIrLed: '红外发光二极管',
    kodenshiCatPointLightSource: '点光源',
    searchPlaceholder: '请输入型号名称',
    categoryPlaceholder: '选择分类',
    model: '型号',
    productName: '产品名称',
    productVersion: '产品版本',
    specs: '规格参数',
    price: '参考价格',
    operation: '操作',
    datasheet: '数据手册类型',
    features: '特性',
    inputType: '输入类型',
    outputType: '输出类型',
    circuitCount: '电路数量',
    supplyVoltageMin: '最小供电电压(V)',
    supplyVoltageMax: '最大供电电压(V)',
    supplyCurrentTyp: '典型供电电流(mA)',
    supplyCurrentMax: '最大供电电流(mA)',
    inputOffsetVoltageTyp: '典型输入偏移电压(mV)',
    inputOffsetVoltageMax: '最大输入偏移电压(mV)',
    propagationDelay: '传播延迟(ns)',
    tempMin: '最低工作温度(°C)',
    tempMax: '最高工作温度(°C)',
    qualityGrade: '质量等级',
    supplyVoltage: '供电电压(V)',
    workingTemp: '工作温度(°C)',
    productDetail: '产品详情',
    packageType: '封装类型',
    railToRail: '轨到轨',
    plp: 'PLP',
    electricalCharacteristics: '电气特性',
    supplyVoltageRange: '供电电压范围',
    typicalSupplyCurrent: '典型供电电流',
    maxSupplyCurrent: '最大供电电流',
    maxInputOffsetVoltage: '最大输入偏移电压',
    typicalInputBiasCurrent: '典型输入偏置电流',
    typicalSlewRate: '典型压摆率',
    typicalGainBandwidth: '典型增益带宽',
    equivalentInputNoise: '等效输入噪声',
    outputCurrent: '输出电流',
    temperatureCharacteristics: '温度特性',
    workingTempRange: '工作温度范围',
    junctionTemp: '结温',
    productFeatures: '产品特性',
    productSpecification: '产品规格书',
    disclaimer: '规格资料仅供参考，本公司并不对资料准确性负责',
    allCategories: '全部',
    consumer: '消费级',
    industrial: '工业级',
    automotive: '汽车级',
    military: '军用级',
    amplifier: '运算放大器',
    amplifierDesc: '高性能运算放大器，适用于精密放大、信号调理等应用',
    comparator: '比较器',
    comparatorDesc: '高速比较器，适用于信号比较、阈值检测等应用',
    special: '特殊功能放大器',
    specialDesc: '特殊功能放大器，包括仪表放大器、差分放大器等专用产品',
    sensorMonitoringAfe: '传感器监测模拟前端（AFE）',
    sensorMonitoringAfeDesc: '专用于传感器监测的模拟前端(AFE)产品系列，提供高精度数据采集解决方案',
    dataConverter: '数据转换器',
    dataConverterDesc: '高性能数据转换器产品系列，包括电压频率转换器等多种转换解决方案',
    ldoLinearRegulator: 'LDO线性稳压器',
    ldoLinearRegulatorDesc: '低压差线性稳压器产品系列，提供稳定的电压输出和优异的线性调节性能',
    dcdcSwitchingRegulator: 'DC/DC开关稳压器',
    dcdcSwitchingRegulatorDesc: '高效率DC/DC开关稳压器产品系列，提供优异的电源转换效率和稳定性能',
    pmics: '电源管理集成电路（PMIC）',
    pmicsDesc: 'PMIC 电源管理芯片产品系列，面向汽车与工业等应用，提供完整电源管理解决方案',
    ioLink: 'IO-Link设备收发器',
    ioLinkDesc: 'IO-Link设备收发器产品系列，为工业自动化应用提供可靠的通信解决方案',
    switchingDriversGate: '栅极驱动器',
    switchingDriversGateDesc: '栅极驱动器产品系列，为功率开关器件提供高效可靠的驱动解决方案',
    switchingDriversHalf: '半桥-全桥驱动器',
    switchingDriversHalfDesc: '半桥-全桥驱动器产品系列，为电机控制和功率转换应用提供专业的驱动解决方案',
    switchingDriversWboost: '带升压转换器的全桥驱动器',
    switchingDriversWboostDesc: '带升压转换器的全桥驱动器产品系列，集成升压功能，为低电压应用提供高效的驱动解决方案',
    switchingICs: '开关 IC（Switch IC）',
    switchingICsDesc: '开关 IC 产品系列，涵盖外接电源开关、过压保护开关等多种开关类集成电路方案',
    shuntRegulators: '分流稳压器（Shunt Regulator）',
    shuntRegulatorsDesc: '分流稳压器产品系列，提供高精度基准与分流稳压方案',
    chargePumps: '电荷泵（Charge Pump）',
    chargePumpsDesc: '电荷泵产品系列，提供负电压转换、倍压转换等方案',
    ssfmOscillator: '扩频振荡器 IC（SSFM）',
    ssfmOscillatorDesc: 'SSFM 扩频调制振荡器集成电路产品系列',
    ledController: 'LED 控制器',
    ledControllerDesc: 'LED 控制器产品系列，提供多通道 LED 驱动与控制方案',
    voltageDetector: '电压检测 IC',
    voltageDetectorDesc: '电压检测与复位类集成电路产品系列',
    resetTimer: '复位定时器',
    resetTimerDesc: '复位定时器产品系列，提供精确复位时序与延时功能',
    liIonBattery: '锂离子电池保护',
    liIonBatteryDesc: '锂离子电池保护与管理集成电路产品系列',
    batteryCharger: '电池充电器',
    batteryChargerDesc: '电池充电管理集成电路产品系列',
    batteryBackup: '电池备份 IC',
    batteryBackupDesc: '电池备份与电源管理集成电路产品系列',
    memsTransducer: 'MEMS 换能器',
    memsTransducerDesc: 'MEMS 传感器与换能器相关集成电路产品系列',
    memsMicrophoneAmplifiers: 'MEMS 麦克风放大器',
    memsMicrophoneAmplifiersDesc: 'MEMS 麦克风专用前置放大器产品系列',
    audioAmplifier: '音频放大器',
    audioAmplifierDesc: '音频放大器产品系列，提供高品质音频放大方案',
    audioSignalProcessor: '音频信号处理器',
    audioSignalProcessorDesc: '音频信号处理与控制产品系列',
    audioSwitch: '音频开关',
    audioSwitchDesc: '音频信号切换与选择开关产品系列',
    videoIC: '视频 IC',
    videoICDesc: '视频信号处理与控制集成电路产品系列',
    audioVideoMisc: '音视频杂项',
    audioVideoMiscDesc: '音视频杂项功能产品系列',
    rfSwitch: '射频开关',
    rfSwitchDesc: '射频信号开关与控制产品系列',
    categoryOthers: '其他',
    rfSwitchCategorySp3Sp4: 'SP3T/SP4T',
    rfSwitchCategorySp5Sp6: 'SP5T/SP6T',
    lowNoiseAmplifier: '低噪声放大器',
    lowNoiseAmplifierDesc: '低噪声放大器产品系列，适用于低噪声信号放大应用',
    sawFilter: 'SAW 声表滤波器',
    sawFilterDesc: '声表面波（SAW）滤波器产品系列',
    fmIfDemodulator: 'FM 中频解调 IC',
    fmIfDemodulatorDesc: 'FM 中频解调集成电路产品系列',
    amplifierPLL: '放大器-锁相环 IC',
    amplifierPLLDesc: '放大器与 PLL 组合集成电路产品系列',
    modulationDemodulationMixer: '调制解调混频 IC',
    modulationDemodulationMixerDesc: '调制、解调与混频器集成电路产品系列',
    stepperMotorDriver: '步进电机驱动器',
    stepperMotorDriverDesc: '步进电机驱动器产品系列',
    threePhaseBLDC: '三相无刷直流预驱动',
    threePhaseBLDCDesc: '三相无刷直流电机预驱动器产品系列',
    singlePhaseBLDC: '单相/两相单极无刷直流预驱动',
    singlePhaseBLDCDesc: '单相/两相单极性无刷直流电机预驱动器产品系列',
    actuatorGateDrivers: '执行器/栅极驱动器',
    actuatorGateDriversDesc: '执行器与栅极驱动器产品系列',
    realTimeClock: '实时时钟（RTC）',
    realTimeClockDesc: '实时时钟集成电路产品系列',
    quartzCrystalOscillator: '石英晶体振荡器 IC',
    quartzCrystalOscillatorDesc: '石英晶体振荡器集成电路产品系列',
    ateAssps: 'ATE 专用芯片（ASSP）',
    ateAsspsDesc: '自动测试设备（ATE）专用集成电路产品系列',
    lcdDrivers: 'LCD 驱动器',
    lcdDriversDesc: '液晶显示（LCD）驱动器产品系列',
    ldDriverICs: '激光二极管驱动 IC',
    ldDriverICsDesc: '激光二极管（LD）驱动集成电路产品系列',
    analogSwitches: '模拟开关',
    analogSwitchesDesc: '模拟开关集成电路产品系列',
    ioPortExpansion: 'IO 端口扩展 IC',
    ioPortExpansionDesc: 'IO 端口扩展集成电路产品系列',
    otherPeripheralICs: '其他外围 IC',
    otherPeripheralICsDesc: '其他外设类集成电路产品系列',
    allModelsDesc: '所有型号产品，包括运算放大器、比较器、特殊功能放大器等',
    keyFeatures: '主要特性',
    func: '功能类型',
    voltageRange: '电压范围',
    note: '备注',
    datasheetType: '数据手册类型',
    isNew: '是否新品',
    new: '新品',
    resolution: '分辨率',
    speed: '速度',
    interface: '接口',
    advantages: '优势',
    currentConsumption: '电流消耗',
    maxCurrentConsumption: '最大电流消耗',
    pinCount: '引脚数',
    downloadDatasheet: '下载数据手册',
    downloadSpec: '下载规格书',
    converterType: '转换器类型',
    outputVoltage: '输出电压',
    inputVoltage: '输入电压',
    inputVoltageRange: '输入电压范围',
    dropoutVoltage: '压差电压',
    quiescentCurrent: '静态电流',
    lineRegulation: '线性调节率',
    loadRegulation: '负载调节率',
    outputNoise: '输出噪声',
    psrr: '电源抑制比',
    enableControl: '使能控制',
    thermalShutdown: '热关断',
    currentLimit: '电流限制',
    operatingTemp: '工作温度',
    applications: '应用领域',
    switchingFrequency: '开关频率',
    efficiency: '效率',
    standard: '标准级',
    grade: '等级',
    functionDesc: '功能描述',
    buckDcdc: '降压 DC/DC（Buck）',
    ldoCount: 'LDO数量',
    vdCount: 'VD数量',
    wdtCount: 'WDT数量',
    gpioCount: 'GPIO数量',
    driveCircuit: '驱动电路',
    switchingCurrent: '开关电流',
    outputRiseTime: '输出上升时间',
    outputFallTime: '输出下降时间',
    fault: '故障检测',
    protections: '保护功能',
    architecture: '架构',
    productUrl: '产品页面',
    visitProductPage: '访问产品页面',
    outputPeakCurrent: '输出峰值电流',
    switchingCurrentBoost: '升压开关电流',
    referenceVoltage: '基准电压',
    tolerance: '容差',
    cathodeCurrent: '阴极电流',
    dynamicImpedance: '动态阻抗',
    temperatureCoefficient: '温度系数',
    frequency: '频率',
    frequencyTolerance: '频率容差',
    supplyCurrent: '供电电流',
    operatingVoltageRange: '工作电压范围',
    channelCount: '通道数',
    ledCurrent: 'LED电流',
    brightnessControl: '亮度控制',
    pwmSteps: 'PWM步数',
    detectionVoltage: '检测电压',
    detectionVoltageAccuracy: '检测电压精度',
    hysteresis: '迟滞',
    resetTimeout: '复位超时',
    operatingTemperature: '工作温度',
    accuracy: '精度',
    outputDelayTime: '输出延时时间',
    outputReleaseTime: '输出释放时间',
    overchargeVoltage: '过充电压',
    overdischargeVoltage: '过放电压',
    overcurrentDetection: '过流检测',
    outputFunction: '输出功能',
    operatingVoltage: '工作电压',
    constantVoltage: '恒压',
    constantCurrent: '恒流',
    linear: '线性',
    switching: '开关',
    normalOperation: '正常工作',
    backUpMode: '备份模式',
    lowDropout: '低压差',
    voltageDetection: '电压检测',
    dualChannel: '双通道',
    singleChannel: '单通道',
    biasVoltage: '偏置电压',
    staticCapacitance: '静态电容',
    chipSize: '芯片尺寸',
    audio: '音频',
    video: '视频',
    microphone: '麦克风',
    transducer: '传感器',
    mems: 'MEMS',
    snr: '信噪比',
    maximumOutputVoltage: '最大输出电压',
    notes: '备注',
    preAmplifier: '前置放大器',
    lowPower: '低功耗',
    amplifierType: '放大器类型',
    control: '控制',
    channel: '通道',
    btl: 'BTL',
    outputPower: '输出功率',
    voltageGain: '电压增益',
    functions: '功能',
    powerType: '电源类型',
    powerAmplifier: '功率放大器',
    headphoneAmplifier: '耳机放大器',
    processorType: '处理器类型',
    volumeRange: '音量范围',
    toneControl: '音调控制',
    inputSelector: '输入选择器',
    inputChannel: '输入通道',
    outputChannel: '输出通道',
    auxInput: '辅助输入',
    auxOutput: '辅助输出',
    licenseFeatures: '授权特性',
    electronicVolume: '电子音量',
    signalProcessor: '信号处理器',
    audioProcessor: '音频处理器',
    dsp: 'DSP',
    input: '输入',
    output: '输出',
    inputOutput: '输入/输出',
    audioSelector: '音频选择器',
    stereo: '立体声',
    mono: '单声道',
    icCategory: 'IC分类',
    gain: '增益',
    driverSeventyFiveOhm: '75Ω驱动',
    lpfThOrder: 'LPF阶数',
    inputChannels: '输入通道',
    outputChannels: '输出通道',
    videoAmplifier: '视频放大器',
    videoSwitch: '视频开关',
    videoFilter: '视频滤波器',
    ecm: 'ECM',
    thd: 'THD',
    misc: '杂项',
    rf: 'RF',
    switch: '开关',
    highFrequency: '高频',
    lowLoss: '低损耗',
    spdt: 'SPDT',
    sp4t: 'SP4T',
    spst: 'SPST',
    dpdt: 'DPDT',
    noiseFigure: '噪声系数',
    iipThree: 'IIP3',
    operatingCurrent: '工作电流',
    packageSize: '封装尺寸',
    poneDb: 'P1dB',
    frontEndModules: '前端模块',
    rfAmplifier: 'RF放大器',
    wideband: '宽带',
    narrowband: '窄带',
    centerFrequency: '中心频率',
    passbandWidth: '通带宽度',
    gps: 'GPS',
    glonass: 'GLONASS',
    galileo: 'Galileo',
    beidou: 'BeiDou',
    wifi: 'WiFi',
    bluetooth: 'Bluetooth',
    cellular: 'Cellular',
    productFunction: '产品功能',
    mixerFrequency: '混频器频率',
    fskComparator: 'FSK比较器',
    filterAmplifiers: '滤波放大器',
    quickCharge: '快速充电',
    rssi: 'RSSI',
    otherFeatures: '其他特性',
    wideBand: '宽带',
    narrowBand: '窄带',
    highPerformance: '高性能',
    referenceFrequency: '参考频率',
    amplifierSupport: '放大器支持',
    pllSupport: 'PLL支持',
    mixerSupport: '混频器支持',
    pll: 'PLL',
    mixer: '混频器',
    modulationDemodulation: '调制解调',
    modulation: '调制',
    demodulation: '解调',
    fsk: 'FSK',
    waveShaping: '波形整形',
    driveMode: '驱动模式',
    inputMode: '输入模式',
    motorCount: '电机数量',
    driverCategory: '驱动器分类',
    logicVoltage: '逻辑电压',
    absoluteMaximumRating: '绝对最大额定值',
    outputModeFeature: '输出模式特性',
    currentSelectFeature: '电流选择特性',
    excitationModeFeature: '激励模式特性',
    vrInputFeature: 'VR输入特性',
    bipolar: '双极性',
    unipolar: '单极性',
    pwm: 'PWM',
    clk: 'CLK',
    outputDriveMode: '输出驱动模式',
    phaseInput: '相位输入',
    leadAngle: '导通角',
    predriverCategory: '预驱动器分类',
    squareWave120: '120°方波',
    squareWave180: '180°方波',
    sineWave: '正弦波',
    singlePhase: '单相',
    twoPhase: '两相',
    gateDriver: '门驱动器',
    actuator: '执行器',
    interfaceType: '接口类型',
    timeKeepingCurrent: '计时电流',
    timeKeepingVoltage: '计时电压',
    timeKeepingVoltageRange: '计时电压范围',
    alarm: '闹钟',
    periodicalInterrupt: '周期中断',
    clockOutput: '时钟输出',
    twoWire: '2线',
    threeWire: '3线',
    i2c: 'I2C',
    spi: 'SPI',
    oscillationFrequency: '振荡频率',
    oscillatorCategory: '振荡器分类',
    divider: '分频器',
    voltageRegulator: '电压调节器',
    cmos: 'C-MOS',
    lvds: 'LVDS',
    lvpecl: 'LVPECL',
    ttl: 'TTL',
    pinElectronics: '引脚电子',
    driver: '驱动器',
    ate: 'ATE',
    test: '测试',
    dutyRatio: '占空比',
    displaySize: '显示尺寸',
    displaySizeSegments: '显示段数',
    displaySizeCommons: '显示公共端数',
    displaySizeLines: '显示行数',
    displaySizeChannels: '显示通道数',
    operatingVoltageVdd: '工作电压VDD',
    operatingVoltageVlcd: '工作电压VLCD',
    ddramBits: 'DDRAM位数',
    evrSteps: 'EVR步数',
    voltageBooster: '电压升压器',
    icon: '图标',
    lcdCategory: 'LCD分类',
    eightBit: '8位',
    fourBit: '4位',
    serial: '串行',
    parallel: '并行',
    channels: '通道',
    ldType: 'LD类型',
    maxOperatingFrequency: '最大工作频率',
    driveCurrentLed: 'LED驱动电流',
    driveCurrentOperating: '工作驱动电流',
    driveCurrentThreshold: '阈值驱动电流',
    ledCurrentMinPulseWidth: 'LED电流最小脉宽',
    risingFallingTime: '上升下降时间',
    maxOutputRatePerChannel: '每通道最大输出速率',
    maxOperatingCurrentLd1: 'LD1最大工作电流',
    maxOperatingCurrentLd2: 'LD2最大工作电流',
    maxOperatingCurrentLd3: 'LD3最大工作电流',
    maxOperatingCurrentLd4: 'LD4最大工作电流',
    aecQ100: 'AEC-Q100',
    protectionCircuit: '保护电路',
    ldCategory: 'LD分类',
    ldCommon: '公共端',
    cathode: '阴极',
    anode: '阳极',
    onStateResistance: '导通电阻',
    analogSwitch: '模拟开关',
    outputPort: '输出端口',
    operatingVoltageMin: '最小工作电压',
    operatingVoltageMax: '最大工作电压',
    operatingVoltageTyp: '典型工作电压',
    min: 'MIN',
    ledDrive: 'LED驱动',
    status: '状态',
    compliant: '兼容',
    peripheral: '外围设备',
    // 菜单分类
    audioICs: '音频IC',
    videoICs: '视频IC',
    powerManagementICs: '电源管理IC',
    batteryManagementICs: '电池管理IC',
    switchingDriverICs: '开关驱动IC',
    signalProcessingICs: '信号处理IC',
    interfaceControlICs: '接口与控制IC',
    specialFunctionICs: '特殊功能IC'
  },
  agentBrands: {
    title: '代理品牌',
    subtitle: '我们与多家知名品牌建立了长期稳定的合作关系',
    brands: {
      nisshinbo: 'Nisshinbo Micro Devices Inc.（日清纺微电子）是一家由原新日本无线（JRC）与理光微电子（Ricoh）于 2022 年合并而成的日本半导体公司。专注于运算放大器（Op-Amps）,电源管理IC（LDO稳压器、DC/DC转换器）, 音频处理IC, 传感器模块与模拟前端（AFE）, 电池管理IC, 微波放大器、滤波器及车用ASIC/ASSP等',
      muses: 'MUSES 系列是为高端音频设备量身打造的旗舰级模拟半导体产品线，涵盖运算放大器、电源管理IC与音量控制器，旨在完美重现「真实原声」。',
      auk: '可天士AUK（沈阳中光电子有限公司，KODENSHI SY Corp.）隶属于 KODENSHI AUK 集团，于1992年8月在沈阳经济技术开发区成立，专注于光电器件的研发、生产与销售，产品涵盖光电二极管、光电三极管、光电开关、编码器、纸张传感器及光电耦合器等，并提供从晶圆制造、IC设计到封装测试、模块开发及 OEM/ODM 的一站式服务。',
      feihong: '广州飞虹半导体科技有限公司（FeiHong Semiconductor Technology Co., Ltd.）成立于2002年，总部位于广州越秀区，是国内领先的IGBT与MOSFET制造商，专注于高功率场效应管和三极管等分立半导体装置的研发、生产与销售，产品广泛应用于家电、LED照明、电源设备、充电器、逆变器、新能源汽车及工业等领域。'
    },
    cooperationTime: '合作时间',
    mainProducts: '主要产品',
    marketCoverage: '市场覆盖',
    cooperationProcess: '合作流程',
    step1: '初步洽谈',
    step1Desc: '了解双方需求',
    step2: '合作评估',
    step2Desc: '商讨合作条件',
    step3: '签订协议',
    step3Desc: '确定合作细节',
    step4: '正式合作',
    step4Desc: '开展业务合作',
    contactTitle: '品牌合作咨询',
    contactDesc: '如果您有意向与我们合作，请填写以下表单，我们将尽快与您联系',
    cooperationIntention: '合作意向',
    submitApplication: '提交申请'
  },
  dealerBrands: {
    title: '经销品牌',
    subtitle: '我们提供多种优质品牌的经销服务',
    advantages: '经销优势',
    advantage1: '优质货源',
    advantage1Desc: '与知名品牌直接合作，确保产品质量',
    advantage2: '价格优势',
    advantage2Desc: '厂家直供，价格优惠，利润空间大',
    advantage3: '营销支持',
    advantage3Desc: '提供专业的营销方案和推广支持',
    advantage4: '售后服务',
    advantage4Desc: '完善的售后服务体系，解决后顾之忧'
  },
  contact: {
    title: '联系我们',
    subtitle: '我们期待与您建立联系',
    contactInfo: '联系方式',
    companyAddress: '公司地址',
    address: '香港沙田小沥源安平街6号新贸中心B座10楼07室',
    addressZhongshan: '中山市民众镇阳光大道中山保税物流中心综合办公大楼808室',
    contactPhone: '联系电话',
    phone1: '(852)2635 2112',
    contactEmail: '电子邮箱',
    email: 'cs@kamzitech.com',
    workingTime: '工作时间',
    weekdays: '周一至周五：9:00 - 17:30',
    onlineMessage: '在线留言',
    companyLocation: '公司位置'
  },
  validation: {
    nameRequired: '请输入姓名',
    phoneRequired: '请输入联系电话',
    emailRequired: '请输入邮箱地址',
    emailFormat: '请输入正确的邮箱地址',
    subjectRequired: '请输入主题',
    messageRequired: '请输入留言内容',
    companyRequired: '请输入公司名称',
    intentionRequired: '请输入合作意向'
  },
  message: {
    submitSuccess: '留言提交成功，我们将尽快与您联系！',
    submitFailed: '提交失败，请稍后重试',
    fetchNewsFailed: '获取新闻失败',
    fetchModelsFailed: '获取型号列表失败',
    fileNotFound: '文件未找到',
    downloadStarted: '下载已开始',
    downloadFailed: '下载失败'
  },
  footer: {
    aboutUs: '关于我们',
    aboutUsDesc: '金矽科技(香港)有限公司',
    contactInfo: '联系方式',
    phone: '电话',
    email: '邮箱',
    address: '地址',
    followUs: '关注我们',
    companyName: '金矽科技(香港)有限公司',
    allRightsReserved: '版权所有',
    whatsappQr: 'WhatsApp二维码',
    wechatQr: '微信二维码',
    telegramQr: 'Telegram二维码',
  }
} 
